import { Select } from '@mantine/core'

import { MODELO_LABEL, type HardwareModel } from '@/api/robo'

const OPCOES = (Object.keys(MODELO_LABEL) as HardwareModel[])
  .map((m) => ({ value: m, label: MODELO_LABEL[m] }))

/** Qual placa é. Fato de hardware, registrado por quem administra a frota —
 *  é ele que escolhe o binário que a gravação pela USB e o OTA entregam. */
export function SeletorDeModelo({ value, onChange, limpavel = true, disabled = false, description }: {
  value: HardwareModel | null
  onChange: (modelo: HardwareModel | null) => void
  limpavel?: boolean
  /** Travado quando o modelo veio da placa: fato lido não se troca à mão. */
  disabled?: boolean
  description?: string
}) {
  return (
    <Select
      label="Modelo"
      description={description ?? 'Qual placa é. Define o firmware que o Console grava; sem ele, o robô não recebe firmware pela USB nem pelo ar.'}
      placeholder="Ainda não sei"
      data={OPCOES}
      value={value}
      onChange={(v) => onChange((v as HardwareModel | null) ?? null)}
      clearable={limpavel}
      allowDeselect={limpavel}
      disabled={disabled}
    />
  )
}
